import { styled } from '@mui/material';

export const StyledLoader = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  paddingTop: theme.spacing(12)
}));
